import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeature, createReducer, on } from '@ngrx/store';
import { Tenant } from '@niko-crm/ui';
import { TenantActions } from './tenant.actions';

export interface TenantState extends EntityState<Tenant> {
  total: number;
  page: number;
  limit: number;
  loading: boolean;
  error: string | null;
}

export const adapter: EntityAdapter<Tenant> = createEntityAdapter<Tenant>();

const initialState: TenantState = adapter.getInitialState({
  total: 0,
  page: 1,
  limit: 20,
  loading: false,
  error: null,
});

export const tenantReducer = createReducer(
  initialState,
  on(TenantActions.loadTenants, (state) => ({ ...state, loading: true, error: null })),
  on(TenantActions.loadTenantsSuccess, (state, { result }) =>
    adapter.setAll(result.data, {
      ...state,
      total: result.total,
      page: result.page,
      limit: result.limit,
      loading: false,
    })
  ),
  on(TenantActions.loadTenantsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(TenantActions.loadActiveTenants, (state) => ({ ...state, loading: true, error: null })),
  on(TenantActions.loadActiveTenantsSuccess, (state, { tenants }) =>
    adapter.setAll(tenants, {
      ...state,
      total: tenants.length,
      loading: false,
    })
  ),
  on(TenantActions.loadActiveTenantsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(TenantActions.createTenantSuccess, (state, { tenant }) => adapter.addOne(tenant, state)),
  on(TenantActions.updateTenantSuccess, (state, { tenant }) =>
    adapter.updateOne({ id: tenant.id, changes: tenant }, state)
  ),
  on(TenantActions.deactivateTenantSuccess, (state, { id }) =>
    adapter.updateOne({ id, changes: { active: false } }, state)
  )
);

export const tenantsFeature = createFeature({
  name: 'adminTenants',
  reducer: tenantReducer,
});
